<template>
  <div>

    <label for="google_file_autocomplete">
        Fichier Google Sheets cible
    </label>

    <Autocomplete
        id="google_file_autocomplete"
        class=" rounded-lg focus:outline-none"
        @submit="(val) => selectedFile = val"
        placeholder="Cherchez un fichier dans votre drive"
        :defaultValue="selectedFile"
        :search="(search) => autocompleteDriveFiles(search)"
        :get-result-value="result => result"
        :autoSelect="true">
        <template #result="{ result, props }">
            <li
                v-bind="props"
                class="autocomplete-result"
            >
                <div class="">
                    {{ result }}
                </div>
            </li>
        </template>
    </Autocomplete>
  </div>

</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import Autocomplete from "@trevoreyre/autocomplete-vue";
import google_service from "../../services/google.js";

const googleFilesSelect = ref([]);
const selectedFile = ref("");
const driveFileSearch = ref("");
const searchTimeout = ref(null);

const errorMessage = ref("");

const props = defineProps({
    credentialName: {
        type: String,
        required: true
    },
    searchMeta: {
        type: String,
        default: "application/vnd.google-apps.spreadsheet",
        required: false
    },

    initialId: {
      type: String,
      required: false
    }
});

const emits = defineEmits(["SelectedFile"]);

watch(() => props.credentialName, async (newVal, oldVal) => {
    driveFileSearch.value = "";
    await loadFileNames();

    // if initialId is set, select it
    if (props.initialId) {
        let fileValue = googleFilesSelect.value.find((file) => {
            return file.value === props.initialId;
        });
        selectedFile.value = fileValue.text;
    }

});

const loadFileNames = async () => {

    console.log("API searching wityh value: ", driveFileSearch.value);
    let files = await google_service.getDriveFiles(props.searchMeta, props.credentialName, driveFileSearch.value) 
                        .catch((err) => {
                            console.log("Error getting files: ", err);
                        });

    console.log("Got files: ", files);
    if (!files) {
        errorMessage.value = "Erreur lors de la récupération des fichiers Drive.";
        return;
    }
    files = files.files;

    if (files.length === 0) {
        errorMessage.value = "Aucun fichier Google Sheets trouvé.";
        return;
    }

    googleFilesSelect.value = files.map((file) => {
        return {
            value: file.id,
            text: file.name
        }
    });
}

const autocompleteDriveFiles = async (search) => {

    if (search === driveFileSearch.value) {
        // return existing results
        let filteredSelect = googleFilesSelect.value.filter((file) => {
            return file.text.toLowerCase().includes(driveFileSearch.value.toLowerCase());
        });
        return filteredSelect.map((file) => {
            return file.text;
        });
    }
    driveFileSearch.value = search;

    return new Promise(resolve => {
        if (searchTimeout.value) {
            clearTimeout(searchTimeout.value);
        }
    
        searchTimeout.value = setTimeout(async () => {
            console.log("Searching for: ", search);
            driveFileSearch.value = search;
            await loadFileNames();
            searchTimeout.value = null;
    
            let filteredSelect = googleFilesSelect.value.filter((file) => {
                return file.text.toLowerCase().includes(search.toLowerCase());
            });
        
            let results = filteredSelect.map((file) => {
                return file.text;
            });
        
            console.log("Search results: ", results)
        
            resolve(results);
        }, 500);
    });
}

watch(selectedFile, async (newVal, oldVal) => {
    console.log("Selected file updated: ", newVal);

    let fileValue = googleFilesSelect.value.find((file) => {
        return file.text === newVal;
    });

    emits("SelectedFile", fileValue);
});

</script>